import { makeStock } from './common';

export interface UpbitTickerPacket {
  code: string;
  timestamp: number;
  opening_price: number;
  trade_price: number;
  acc_trade_volume: number;
}
export interface CobitTickerPacket {
  currency_pair: string;
  timestamp: number;
  open: string;
  last: string;
  volume: string;
}
export interface BithumbTickerPacket {
  symbol: string;
  timestamp: number;
  openPrice: string;
  closePrice: string;
  volume: string;
}

export const upbitTicker = (data: UpbitTickerPacket) => makeStock(
  data.code,
  data.code,
  data.timestamp,
  data.opening_price,
  data.trade_price,
  data.acc_trade_volume,
)

export const cobitTicker = (data: CobitTickerPacket) => makeStock(
  data.currency_pair,
  data.currency_pair,
  data.timestamp,
  data.open,
  data.last,
  data.volume,
)

export const bithumbTicker = (data: BithumbTickerPacket) => makeStock(
  data.symbol,
  data.symbol,
  data.timestamp,
  data.openPrice,
  data.closePrice,
  data.volume,
)